export const defaultState = {
  env: null,
  loading: false,
  onWait: false,
  user: {},
  fetchingUser: true,
};
